import { type Product, type WithContext } from 'schema-dts'

import { type PimProductV11 } from '@redteclab/api/clients/bully'

import { productDataAccessorGetManufacturerCode } from '../../model/productDataAccessor'

import { getOfferSchema } from './getOfferSchema'
import { getAggregatedRatingSchema } from './getRatingSchema'
import { type PartiallyRequired } from './jsonLdSchema.types'

/**
 * Undefined values cut during serialization, but Google requires them,
 * so we fill keys with empty strings
 */
type GoogleVariantProduct = PartiallyRequired<
  WithContext<Product>,
  'brand' | 'description' | 'image' | 'mpn' | 'name' | 'sku' | 'url'
>

export const getVariantSchema = (
  variant: PimProductV11,
  isMarketplace: boolean,
  fallback: string,
): GoogleVariantProduct => ({
  '@context': 'https://schema.org',
  '@type': 'Product',
  aggregateRating: getAggregatedRatingSchema(
    Number(variant.rating?.average.toFixed(1)),
    variant.rating?.count,
  ),
  brand: variant.brand?.name ?? '',
  description: variant.description_short ?? variant.description_extra ?? '',
  image: variant.images?.at(0) ?? fallback,
  mpn: productDataAccessorGetManufacturerCode(variant) ?? '',
  name: variant.name,
  offers: getOfferSchema(variant, isMarketplace, true),
  sku: variant.upid,
  url: variant.canonical_url,
})
